// extracted by mini-css-extract-plugin
module.exports = {"MaterialsHeading":"MaterialsHeading_MaterialsHeading__Yw43u","heading":"MaterialsHeading_heading__jyods"};